// extracted by mini-css-extract-plugin
module.exports = {"AuthorSmallBox":"AuthorSmallBox_AuthorSmallBox__j1Wll"};